import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './sourcesofincome.css'

const SourcesOfIncome = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>Three sources of incomes for content owners</h1>
      <div className={commonStyles.subheading}>We make the sample business a new revenue source for you</div>
      <div className={styles.infographicsWrapper}>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img className={styles.infographicImg} src="/static/images/interestform/record-illustration.jpg" alt="Record Illustration" />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>1. Track Access</strong>
            </div>
            <div className={styles.infographicText}>Content owners earn money on track downloads on subscriptions</div>
          </div>
        </div>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img
              className={styles.infographicImg}
              src="/static/images/interestform/contract-illustration.jpg"
              alt="Contract Illustration"
            />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>2. License Fees</strong>
            </div>
            <div className={styles.infographicText}>Content owners get a share of the admin fee depending on category</div>
          </div>
        </div>
        <div className={styles.infographic}>
          <div className={styles.infographicImageWrapper}>
            <img className={styles.infographicImg} src="/static/images/interestform/dollar-illustration.jpg" alt="Dollars" />
          </div>
          <div className={styles.infographicTextWrapper}>
            <div className={styles.infographicTitle}>
              <strong>3. Derivatives</strong>
            </div>
            <div className={styles.infographicText}>
              Master owners share in the new master revenues and Composition owners share publishing copyright in the new songs
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default SourcesOfIncome
